import { INonInventory } from "@/shared/types";

import { INonInventoryModified } from "../model/types/interfaces";

export const modifyManyNonInventoryData = (
  items: Array<INonInventory>
): Array<INonInventoryModified> => {
  return items.map((element) => {
    return { ...element };
  });
};

export const modifyOneNonInventoryData = (request: INonInventory): INonInventoryModified => {
  return { ...request };
};

export const getUpdateDtoByFormData = (formData: any) => {
  const a: any = {
    rejectedReason: formData.rejectedReason,
    acceptedMessage: formData.acceptedMessage,
    status: formData.status,
  };

  return a;
};
